export * from './header/header.component';
export * from './footer/footer.component';
export * from './tiny-mce/tiny-mce.component';
export * from './switcher/switcher.component';
